import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { StreamParam } from '../_helpers/streamSearchParam';
import { StreamsFilterAction, NodeStreamsFilterAction } from '../streamsFilter.action';

export const clearSelectStreamEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    StreamsFilterAction.clearSelect,
    NodeStreamsFilterAction.clearSelect,
  ),
  map(() => {
    return RouterAction.removeParam(StreamParam.name);
  }),
);
